import classNames from './ChangeLevelPopup.module.scss';
import { useAdminTranslation } from '@/admin/hooks/useAdminTranslation';
import { StudentReportItem } from '@/school-management/types/response';
import {
  BulkOperationResponseData,
  BulkOperationState,
} from '@/school-management/types/services/bulk';
import Button from '@/components/school-management/Button/Button';
import Download from './Download';
import AppIcon from '@/components/school-management/AppIcon/AppIcon';

interface FailureProps {
  students: StudentReportItem[];
  newLevelLabel: string;
  bulkOperation?: BulkOperationResponseData;
  onClose: () => void;
}

const Failure = ({ students, newLevelLabel, bulkOperation, onClose }: FailureProps) => {
  const { t } = useAdminTranslation();

  return (
    <>
      <button
        className={classNames.closeBtn}
        onClick={onClose}
        aria-label={t('common.cancel') || 'Close'}
      >
        <AppIcon icon='close' size={20} />
      </button>
      <AppIcon size={80} icon='error' className={classNames.icon} />
      <div>
        <div className={classNames.title} style={{ fontSize: '26px' }}>
          {t('bulkActions.changeLevel.failure.title')}
        </div>
        <div className={classNames.description}>
          {t('bulkActions.changeLevel.failure.description')}
        </div>
      </div>
      <Download
        students={students}
        newLevelLabel={newLevelLabel}
        bulkOperation={bulkOperation}
        bulkOperationState={BulkOperationState.Failed}
      />
      <div className={classNames.footer} style={{ width: '433px', flexDirection: 'column' }}>
        <Button className={classNames.button} onClick={onClose}>
          {t('close')}
        </Button>
      </div>
    </>
  );
};

export default Failure;
